// Strip a trailing size (10mg / 3.5ml / 10000IU) from a product name for grouped display.
export function baseName(name) {
  return name.replace(/\s*\d+(\.\d+)?\s*(mg|ml|iu)\b.*$/i, "").trim() || name;
}

// Collapse products that share a `group` into one entry with a sorted `variants` array.
export function groupProducts(products) {
  const buckets = {};
  const order = [];
  for (const p of products) {
    const key = p.group || p.slug;
    if (!buckets[key]) { buckets[key] = []; order.push(key); }
    buckets[key].push(p);
  }
  return order.map((k) => {
    const variants = buckets[k].slice().sort((a, b) => a.price - b.price);
    return { key: k, variants, rep: variants[0] };
  });
}
